(ns bec-core.cljs.views.login
  (:require [reagent.core :as r] 
            [re-frame.core :as rf]
            [bec-cljs-common.utils.formatting :refer [capitalize-words]]
            [bec-core.cljs.components.logo :refer [app-logo]]
            [bec-cljs-common.components.button :refer [button link]]
            [bec-cljs-common.components.input :refer [field-input prompt-message]]))

(defn login-input [& [props]]
  (let [keypad-props (:keypad-props props)
        input (:input keypad-props)
        valid-input? (when (false? (:valid-input? keypad-props))
                       (:valid-input? keypad-props))
        active-input? (and input (not (= "" input)))]
    [field-input
     {:control-props (merge (:control-props props)
                       {:field-props {:style {:margin-bottom "0.5rem"
                                              :width "100%"}}})
      :input-props (merge
                     {:class " is-info is-rounded"
                      :id (:id props)
                      :value input
                      :on-focus #(rf/dispatch [:assoc-in [:login :login-failed?] false])
                      :on-change #(rf/dispatch [:keyboard-button-press
                                                {:keypad-id (:id props)
                                                 :input (-> % .-target .-value)}])}
                     (:input-props props))
      :valid-input? valid-input?
      :active-input? active-input?
      :icon-left (:icon-left props)
      :icon-right (:icon-right props)
      :icon-right-props (:icon-right-props props)}]))

(defn login []
  (let [username-id "login-username"
        password-id "login-password"
        username-keypad-props @(rf/subscribe [:keypad username-id])
        username-input (:input username-keypad-props)
        password-keypad-props @(rf/subscribe [:keypad password-id])
        password-input (:input password-keypad-props)
        login @(rf/subscribe [:login])
        user {:name "Shako Farhad"
              :two-factor-authentication {:enabled? true
                                          :type "email"}
              :admin? true
              :username "Shako"
              :password "password"}]
    #_(if-let [user user #_@(rf/subscribe [:get-in [:bec-core-server :shared-state :users 
                                                  username-input]])]
      (if true ;;(and (= username-input (:username user)) (= password-input (:password user)))
        (rf/dispatch [:dispatch-many
                      [[:dispatch [:select-view :home]]
                       [:dispatch [:assoc-in [:login] user]]
                       [:dispatch [:assoc-in [:login :logged-in?] true]]]])
        (rf/dispatch [:assoc-in [:login :login-failed?] true]))
      (rf/dispatch [:assoc-in [:login :login-failed?] true]))
    #_[:div.fade-in
     {:style {"--fade-in-duration" "1000ms"}}
     [:div.container.is-fluid
      {:style {:height "100vh"
               :display "flex"
               :justify-content "center"
               :align-items "center"
               :flex-direction "column"}}
      [:div.box
       {:style {:position "relative"
                :display "flex"
                :flex-direction "column"
                :align-items "center"
                :padding-top "5rem"
                :max-width "25rem"}}
       [app-logo
        {:style {:position "absolute"
                 :height "7rem"
                 :top "-3.5rem"}}]
       [login-input
        {:id username-id
         :keypad-props username-keypad-props
         :input-props {:type "text"
                       :placeholder "Username"}
         :icon-left "fas fa-user"
         :icon-right false}]
       [login-input
        {:id password-id
         :keypad-props password-keypad-props
         :input-props {:type (if (:show-password? login)
                               "text"
                               "password")
                       :placeholder "Password"
                       :on-key-up (fn [event]
                                    (when (or (= event.key "Enter") (= event.keyCode 13))
                                      (login-submit-button-fn)))}
         :icon-left "fas fa-key"
         :icon-right (if (:show-password? login)
                       "fas fa-eye-slash"
                       "fas fa-eye")
         :icon-right-props {:class "is-rounded"
                            :style {:color "var(--blue)"}
                            :on-click #(rf/dispatch [:assoc-in [:login :show-password?] (not (:show-password? login))])}}]
       [button
        {:class "is-fullwidth is-primary is-rounded"
         :style {:z-index "1"
                 :margin "0"}
         :disabled (or (not username-input) (= "" username-input)
                     (not password-input) (= "" password-input))
         :on-click login-submit-button-fn}
        "Login"]
       [prompt-message
        {:show-prompt? (:login-failed? login)
         :class "is-warning "
         :style {:border-radius "1.25rem"
                 :margin-bottom "0.5rem"}}
        "The username or password is incorrect."]
       [link
        {:on-click #(rf/dispatch [:select-view :login {:login-help? true}])}
        "Can't log in?"]]]]))

(defn login-help []
  [:div.fade-in
   {:style {"--fade-in-duration" "1000ms"}}
   [:div.container.is-fluid
    {:style {:height "100vh"
             :display "flex"
             :justify-content "center"
             :align-items "center"
             :flex-direction "column"}}
    [:h1.title
     {:style {:max-width "50rem"
              :text-align "center"}}
     "Can't log in?"]
    [:p.subtitle
     {:style {:max-width "50rem"
              :text-align "center"}}
     "There may be many reasons for why you can't log in. Here are some options"]
    [link
     {:on-click #(rf/dispatch [:select-view :login])}
     "Forgot username"]
    [link
     {:on-click #(rf/dispatch [:select-view :login])}
     "Reset password"]]])

(defn view [& [props]]
  (if (:login-help? props)
    [login-help]
    [login]))
